import { PaymentSchedule } from "@app/models/PaymentSchedule";
import { Inject, Injectable } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { PaymentScheduleSelectorDialog } from "@app/components/paymentSchedule/paymentScheduleSelector.dialog";

@Injectable({ providedIn: "root" })
export class PaymentScheduleSelectorComponent {

    private paymentSchedules: PaymentSchedule[];

    constructor(@Inject(MatDialog) private dialog: MatDialog) {}

    loadPaymentSchedule(paymentSchedules: PaymentSchedule[]) {
        this.dialog.open(PaymentScheduleSelectorDialog, {
            closeOnNavigation: false,
            disableClose: true,
            data: { paymentSchedules },
        })
    }
}

